import React, { PropsWithChildren } from 'react';

import cx from 'classnames';
import { FieldPath } from 'react-hook-form';
import { useToggleLayer } from 'react-laag';

import { DatePicker, withDateResolver } from 'components/shared/DatePicker';
import { AdapterType } from 'utils/types';

import { PopoverLayer } from '../shared';
import s from '../shared.module.css';
import { FieldValues, TDatePickerProps } from './type';

const ResolvedDatePicker = withDateResolver(DatePicker);

const DatePickerPopover = function <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(props: AdapterType<TFieldValues, TName> & PropsWithChildren<TDatePickerProps>) {
  const { children, mode, disabled, disabledDates, position = 'BOTTOM_CENTER', closeOnSelect, field, ...rest } = props;
  const { value, onChange, onBlur } = field;

  // TODO: upgrade TS 5v
  const pickerProps = (() => {
    if (mode === 'range') return { mode, selected: value, onSelect: onChange };
    return { mode, selected: value, onSelect: onChange };
  })();

  const restProps = { onDayBlur: onBlur, disabled: disabledDates, ...rest };

  const [popoverElement, toggleLayerProps] = useToggleLayer(
    (toggleProps) => (
      <PopoverLayer {...toggleProps}>
        <ResolvedDatePicker {...pickerProps} {...restProps} />
      </PopoverLayer>
    ),
    {
      placement: {
        anchor: position,
        possibleAnchors: ['BOTTOM_CENTER', 'TOP_CENTER', 'BOTTOM_LEFT', 'TOP_LEFT'],
        autoAdjust: true,
        triggerOffset: 10,
      },
      closeOnOutsideClick: true,
      fixed: true,
    },
  );

  React.useEffect(() => {
    if (closeOnSelect) toggleLayerProps.close();
  }, [value]);

  return (
    <React.Fragment>
      {popoverElement}

      <button
        type="button"
        onClick={toggleLayerProps.openFromMouseEvent}
        className={cx(s.resetButton, s.popoverButton)}
        disabled={disabled}
      >
        {children}
      </button>
    </React.Fragment>
  );
};

export { DatePickerPopover };
export default DatePickerPopover;
